"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavLink = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
exports.NavLink = styled_components_1.styled.a(({ theme, mode, slim }) => `
  cursor: pointer;
  color: ${mode === "active" ? theme.activeRouteColor : "currentcolor"};
  border-bottom: 2px solid ${mode === "active" ? theme.activeRouteColor : "#0000"};
  align-self: stretch;
  display: flex;
  align-items: center;
  padding: ${theme.gutterHeader + (slim ? " 0" : "")};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  &:hover {
    border-bottom-color: ${mode === "active" ? theme.activeRouteColor : theme.headerFg};
  }
  @media (max-width: ${theme.screen.small}) {
    padding: 10px;
  }
`);
//# sourceMappingURL=NavLink.js.map